import {
  setConfiguration,
  WidgetAfterSaveMethods,
} from '@configuratorware/configurator-frontendgui/App/configuration';
import Api from '@configuratorware/configurator-frontendgui/Framework/Api';
import CustomConfiguratorScreen from './App/Screens/ConfiguratorScreen';
import InteractionService from './App/Services/InteractionService';
import ConfiguratorService from './App/Services/ConfiguratorService';
import hintMessagesReducer from './App/Reducers/HintMessages/Reducers';
import CustomCalculationWidgetScreen from './App/Screens/CalculationWidgetScreen';
import DesignDataService from './App/Services/DesignDataService';

const prod = process.env.NODE_ENV === 'production';

const envDomains = {
  test: '',
  int: 'http://int.langenberg-designer.local',
  local: 'http://localhost:8080',
  prod: '',
};

const domain = envDomains[prod ? 'prod' : 'int'];

const query = new URLSearchParams(location.search);

const adminMode = query.get('_adminmode');

const customApplicationConfiguration = {
  network: {
    // timeout: 40000,
    host: domain,
    baseURL: `${domain}/frontendapi/`,
    adminBaseURL: `${domain}/api/`,
    imageURL: `${domain}`,
    resourcesURL: `${domain}`,
  },
  screens: {
    Configurator: CustomConfiguratorScreen,
    CalculationWidget: CustomCalculationWidgetScreen,
  },
  reducers: {
    hintMessages: hintMessagesReducer,
  },
  services: {
    InteractionService,
    ConfiguratorService,
    DesignDataService,
  },
  openConfigurator: {
    method: WidgetAfterSaveMethods.PostMessage,
  },
  disableBeforeunloadWarning: true,
};
if (query.has('_context_token')) {
  Api.setGETParameter('_context_token', encodeURIComponent(query.get('_context_token')));
}
setConfiguration(customApplicationConfiguration);

if (adminMode) {
  // in admin mode all requests should contain the no-cache header to get the most fresh content
  Api.setCacheControlHeader('no-cache');
}

export default customApplicationConfiguration;
